/* eslint-disable */
// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@carbon/react";
import Button, { Icons } from "../buttons/Button";
import { ReactComponent as ModalCautionIcon } from "../../assets/icons/icon-park-solid_caution.svg";
import {
  BULK_UPLOAD_GENERAL_TRANSLATIONS,
  EDIT_ROW_TRANSLATIONS,
} from "../../translations/util";
import LinearProgressBar from "../../ui/LinearProgressBar";

export enum BulkUploadModalIcons {
  Caution,
}

const getModalIconFromName = (IconName: BulkUploadModalIcons) => {
  switch (IconName) {
    case BulkUploadModalIcons.Caution:
      return <ModalCautionIcon />;
    default:
      return null;
  }
};

interface IProps {
  modalHeaderText: string;
  modalDescriptionText: string;
  cancelIcon?: BulkUploadModalIcons;
  open: boolean;
  setOpen: (active: boolean) => void;
  preventCloseOnClickOutside?: boolean;
  maxRowCount?: number;
  count?: number;
  moduleName: string;
}

const BulkUploadModal = ({
  modalHeaderText,
  modalDescriptionText,
  cancelIcon,
  open,
  setOpen,
  preventCloseOnClickOutside = true,
  maxRowCount = 0,
  count = 0,
  moduleName,
}: IProps) => {
  useEffect(() => {
    if (count === -1) {
      setTimeout(() => {
        setOpen(false);
      }, 2000);
    }
    if (count === maxRowCount) {
      setTimeout(() => {
        setOpen(false);
      }, 1000);
    }
  }, [count]);

  const running = count > 0;
  let progressHelperText = running
    ? BULK_UPLOAD_GENERAL_TRANSLATIONS.BulkUploadModal.handleProgressHelperText(
        count,
        maxRowCount,
        moduleName
      )
    : BULK_UPLOAD_GENERAL_TRANSLATIONS.BulkUploadModal.waitingHelperText;
  if (count >= maxRowCount) {
    progressHelperText =
      BULK_UPLOAD_GENERAL_TRANSLATIONS.BulkUploadModal.doneHelperText;
  }
  return (
    <ComposedModal
      className="modal-content"
      size="sm"
      open={open}
      setOpen={setOpen}
      preventCloseOnClickOutside={preventCloseOnClickOutside}
      selectorPrimaryFocus={".w-full"}
    >
      <ModalHeader
        data-cy={`${modalHeaderText.split(" ").join("")}-modalHeader`}
        className="bulk-upload-modal"
      >
        <>
          <h4 className="flex" data-cy="modal-heading">
            <span className="modal-icon" data-cy="modalIcon">
              {getModalIconFromName(cancelIcon) ||
                getModalIconFromName(BulkUploadModalIcons.Caution)}
            </span>
            {modalHeaderText}
          </h4>
          <p
            className="bulk-upload-modal-description-text"
            data-cy="modal-description-text"
          >
            {modalDescriptionText}
          </p>
        </>
      </ModalHeader>
      <ModalBody hasForm>
        <LinearProgressBar
          max={maxRowCount}
          moduleName={moduleName}
          count={count}
          helperText={progressHelperText}
          running={running}
        />
      </ModalBody>
    </ComposedModal>
  );
};
export default BulkUploadModal;
